var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minimap"},[_c('img',{attrs:{"src":_vm.img}}),_c('div',{staticClass:"I1Btn",style:({top:(_vm.y/2) + 'px',left:(_vm.x/2)+'px'})},[_vm._v("X")])])}
var staticRenderFns = []

export { render, staticRenderFns }